/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'news-feed-ipo': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="currentColor" stroke-width="2" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><circle pid="0" cx="16" cy="16" r="15"/><path pid="1" d="M9 22v-6h4v-3h4V9h6v15l-6-1h-2l-6 1v-2zm2-.333l2-.334V18h-2v3.667zm10 0V11h-2v10.333l2 .334zM15 16v5h2v-6h-2v1z" _fill="currentColor" _stroke="none"/></g>'
  }
})
